import './component';
import './config';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-faq',
    label: 'acris-faq.elements.faqGroups.label',
    component: 'sw-cms-el-acris-faq',
    configComponent: 'sw-cms-el-config-acris-faq',
    previewComponent: 'sw-cms-el-preview-acris-faq',
    defaultConfig: {
        faqGroups: {
            source: 'static',
            value: []
        },
        faqGroupLoaded: {
            source: 'static',
            value: 'manual'
        }
    }
});
